import axios from 'axios';
import { createAsyncThunk, isFulfilled, isPending } from '@reduxjs/toolkit';
import { cleanEntity } from '../../../../../app/shared/util/entity-utils';
import { IQueryParams, createEntitySlice, EntityState, serializeAxiosError } from '../../../app/shared/reducers/reducer.utils';
import { defaultValue, ICaseLawyer } from '../../shared/model/case-lawyer.model';

const initialState: EntityState<ICaseLawyer> = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
  steps: [],
};

const apiUrl = `api/stripe/dyhac/user-subscriptions`;

export const getEntity = createAsyncThunk('planDetails/fetch_entity', async (id: string | number) => {
  const requestUrl = `${apiUrl}/${id}`;
  const response = await axios.get<any | []>(requestUrl);
  return response;
});

export const SubscriptionPlanSlice = createEntitySlice({
  name: 'subscriptionPlan',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getEntity.fulfilled, (state, action) => {
        state.loading = false;
        state.entities = action.payload?.data;
        state.entity = Array.isArray(action.payload?.data) ? action.payload?.data[action.payload?.data.length - 1] : action.payload?.data;
      })
      .addCase(getEntity.rejected, (state, action) => {
        state.loading = false;
        state.entities = [];
      })
      .addMatcher(isFulfilled(getEntity), (state, action) => {
        const { data, headers } = action.payload;
        return {
          ...state,
          loading: false,
          entities: data,
          totalItems: parseInt(headers['x-total-count'], 10),
        };
      });
  },
});

export const { reset } = SubscriptionPlanSlice.actions;

// Reducer
export default SubscriptionPlanSlice.reducer;
